import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

// Custom Arrow Components
const PrevArrow = ({ onClick }) => (
  <button
    className="absolute top-1/2 left-[-30px] z-10 bg-gray-800 text-white p-2 rounded-full shadow-lg transform -translate-y-1/2 hover:bg-gray-700"
    onClick={onClick}
  >
    <FaArrowLeft size={20} />
  </button>
);

const NextArrow = ({ onClick }) => (
  <button
    className="absolute top-1/2 right-[-30px] z-10 bg-gray-800 text-white p-2 rounded-full shadow-lg transform -translate-y-1/2 hover:bg-gray-700"
    onClick={onClick}
  >
    <FaArrowRight size={20} />
  </button>
);

const ProductDetails = () => {
  const { slug } = useParams();
  const [product, setProduct] = useState(null);
  const [moreProducts, setMoreProducts] = useState([]);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/products.json`)
      .then((response) => response.json())
      .then((data) => {
        console.log("Fetched JSON data:", data);

        if (data.categories) {
          const allProducts = data.categories.flatMap((category) => category.products);
          const foundProduct = allProducts.find((item) => item.slug === slug);
          setProduct(foundProduct);

          // Set "More Products" (all other products excluding current one)
          const remainingProducts = allProducts.filter((prod) => prod.slug !== slug);
          setMoreProducts(remainingProducts);
        }
      })
      .catch((error) => console.error("Error fetching product:", error));
  }, [slug]);

  if (!product) {
    return <p className="text-center text-lg">Loading product details...</p>;
  }

  // Slider settings with custom arrows
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="container mx-auto px-8 py-2 md:py-16 lg:py-16">
      <div className="flex flex-col md:flex-row mx-auto items-center md:space-x-8">
        {/* Product Image */}
        <div className="md:w-2/5">
          <img
            src={product.image}
            alt={product.name}
            className="lg:h-[40vh] px-12 object-contain"
          />
        </div>

        {/* Product Info */}
        <div className="md:w-3/5">
          <h2 className="text-xl md:text-3xl font-bold text-primary mb-4">{product.name}</h2>
          <p
            className="text-gray-800 text-justify mb-4 text-sm md:text-lg"
            dangerouslySetInnerHTML={{ __html: product.content }}
          />
          {product.file && (
            <a
              href={product.file}
              className="inline-block bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
            >
              Download Datasheet
            </a>
          )}
        </div>
      </div>

      {/* More Products Section (Slider) */}
      {moreProducts.length > 0 && (
        <div className="mt-16  relative">
          <h3 className="text-2xl font-bold text-primary mb-6 text-center">More Products</h3>
          <Slider {...settings}>
            {moreProducts.map((product) => (
              <div key={product.id} className="p-4">
                <div className="shadow-lg rounded-lg overflow-hidden">
                  <a href={`/product/${product.slug}`}>
                    <img
                      src={product.image}
                      alt={product.name}
                      className="h-40 w-full object-contain"
                    />
                    <h5 className="my-2 text-center text-lg font-semibold text-gray-700">
                      {product.name}
                    </h5>
                  </a>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      )}
    </div>
  );
};

export default ProductDetails;
